var React = require('react');

function ErrorMark (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.333 30C3.333 15.272 15.272 3.333 30 3.333S56.667 15.272 56.667 30 44.728 56.667 30 56.667 3.333 44.728 3.333 30","stroke":"#B01B0E","fill":"none","key":0}),React.createElement("path",{"d":"M32.5 42.5c0 .69-.244 1.28-.732 1.768S30.69 45 30 45s-1.28-.244-1.768-.732S27.5 43.19 27.5 42.5s.244-1.28.732-1.768S29.31 40 30 40s1.28.244 1.768.732.732 1.077.732 1.768l-.002.087","fill":"#B01B0E","key":1}),React.createElement("path",{"d":"M29.942 17.442v16.783","stroke":"#B01B0E","strokeLinecap":"square","fill":"none","key":2})]);
}

ErrorMark.defaultProps = {"viewBox":"0 0 60 60","width":"60","height":"60"};

module.exports = ErrorMark;

ErrorMark.default = ErrorMark;
